import { Period } from '#/shared/api/generated/analytics/models'

export const PIPELINE_RANGE_KEYS = {
  SEVEN_DAYS: 'sevenDays',
  THIRTY_DAYS: 'thirtyDays',
  QTD: 'qtd',
} as const

export type PipelineRangeKey =
  (typeof PIPELINE_RANGE_KEYS)[keyof typeof PIPELINE_RANGE_KEYS]

export const PIPELINE_RANGE_TO_PERIOD: Record<PipelineRangeKey, Period> = {
  [PIPELINE_RANGE_KEYS.SEVEN_DAYS]: Period['7d'],
  [PIPELINE_RANGE_KEYS.THIRTY_DAYS]: Period['30d'],
  [PIPELINE_RANGE_KEYS.QTD]: Period.qtd,
}

export const PIPELINE_DELTA_DIRECTIONS = {
  UP: 'up',
  DOWN: 'down',
  FLAT: 'flat',
} as const

export type PipelineDeltaDirection =
  (typeof PIPELINE_DELTA_DIRECTIONS)[keyof typeof PIPELINE_DELTA_DIRECTIONS]

export function pipelineDeltaDirection(
  value: number | null | undefined,
): PipelineDeltaDirection {
  if (value == null || value === 0) return PIPELINE_DELTA_DIRECTIONS.FLAT
  return value > 0
    ? PIPELINE_DELTA_DIRECTIONS.UP
    : PIPELINE_DELTA_DIRECTIONS.DOWN
}
